import React, { Component } from 'react';
import { Spin } from 'antd';
import "antd/dist/antd.css";
import styles from './styles.scss';

class WSpinner extends Component 
{
  render() 
  { 
    
    return (
      <Spin />
    );
  }
}

export default WSpinner;



// WEBPACK FOOTER //
// ./src/components/WSpinner/WSpinner.js